import { render, staticRenderFns } from "./lifecycle-table.vue?vue&type=template&id=c133f974&scoped=true"
import script from "./lifecycle-table.vue?vue&type=script&lang=js"
export * from "./lifecycle-table.vue?vue&type=script&lang=js"
import style0 from "./lifecycle-table.vue?vue&type=style&index=0&id=c133f974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c133f974",
  null
  
)

export default component.exports